// extracted by mini-css-extract-plugin
export default {"parent":"FaqParent_parent__uY+d1","head":"FaqParent_head__BMkng","img1":"FaqParent_img1__bJ3dD","floatUpDown":"FaqParent_floatUpDown__FOn3f","img2":"FaqParent_img2__Aic5b"};